import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { startWith } from 'rxjs/operators';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { Batch, LinkOrderItemToBatchPayload } from 'src/interfaces/batch';
import { OrderItem } from 'src/interfaces/order-item';

export interface DialogData {
  title: string;
  message: string;
  orderItem: OrderItem;
}

@Component({
  selector: 'core-link-order-item-to-batch-dialog',
  templateUrl: './link-order-item-to-batch-dialog.component.html',
  styleUrls: ['./link-order-item-to-batch-dialog.component.scss']
})
export class LinkOrderItemToBatchDialogComponent implements OnInit {
  batchNumber = new FormControl('', Validators.required);
  batches: Batch[] = [];
  selectedBatch: Batch | null = null;
  constructor(
    public _dialogRef: MatDialogRef<LinkOrderItemToBatchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _prescriptionService: PrescriptionService,
  ) { }

  ngOnInit(): void {
    this
      .batchNumber
      .valueChanges
      .pipe(
        startWith("")
      )
      .subscribe(value => {
        this.getBatches(value)
      });
  }

  async getBatches(value: string) {
    this.batches = await this
      ._prescriptionService
      .searchBatches(1, 15, value);

    this.batches = this.batches.filter(batch => {
      if (!batch.status) return false;
      return (batch.status.code === 'ISK'
        &&
        batch.medicine_dosage_type.medicine.name === this.data.orderItem.medicine.name)
    })
  }

  batchSelected(event: MatAutocompleteSelectedEvent) {
    this.selectedBatch = event.option.value;

    if (!this.selectedBatch) return;

    this.batchNumber
      .patchValue(this.selectedBatch.batch_number);
  }

  async linkToBatch() {
    
    if (!this.selectedBatch) {
      alert("Please select a batch");
      return;
    }

    if (!this.data.orderItem.id)
      return;

    const payload: LinkOrderItemToBatchPayload = {
      order_item_id: this.data.orderItem.id,
      quantity: this.data.orderItem.quantity
    };

    const success = await this._prescriptionService
      .linkToBatch(this.selectedBatch.id, payload);

    if (success)
      this._dialogRef.close(success);

  }

}
